/* sp-pdp-extras.js — opt-ins de la ficha del kit Shopify maker (2026-10-19; CONTRACTS §K.3, §H.4). Lo cargan con defer
   snippets/sp-sticky-atc.liquid (con settings.sp_sticky_atc_price) y snippets/sp-delivery.liquid (con save_format
   'amount'); sin ellos no se pide. Idempotente (flag global) y por delegación en document: sobrevive a los re-renders del
   editor. Sin listeners de scroll ni de gesto.
   (1) Precio del botón flotante [data-sp-sticky] > [data-sp-sticky-price]: con el bundle de ese form, el total de la
       opción elegida (data-sp-final, que sp-bundle.js recalcula con la variante; redondeado a unidades con data-sp-whole);
       sin bundle, el de la variante (data-price del flotante, que sigue a variant:change). En sp:bundle:change y
       variant:change (en la vuelta siguiente: sp-bundle.js recalcula primero).
   (2) Tarjeta de precio de la preventa con el ahorro en monto [data-sp-delivery-price]: precio, tachado, "Ahorrás $N"
       (data-sp-tpl-badge) y la línea para lectores (data-sp-tpl-aria) siguen a la variante en variant:change; sin precio
       anterior en la variante queda como estaba.
   Montos con theme.Currency.formatMoney y el formato de la tienda (sin etiquetas); sin el formateador del tema, el texto
   del servidor. */
(function () {
  'use strict';
  if (window.__spPdpExtrasInit) return;
  window.__spPdpExtrasInit = true;

  function toArray(list) { return Array.prototype.slice.call(list || []); }

  function fmt(cents) {
    var t = window.theme;
    if (!t || !t.Currency || typeof t.Currency.formatMoney !== 'function') return null;
    return String(t.Currency.formatMoney(cents, t.settings && t.settings.moneyFormat)).replace(/<[^>]*>/g, '');
  }

  function stickyPrice(wrap) {
    var el = wrap.querySelector('[data-sp-sticky-price]');
    if (!el) return;
    var formId = wrap.getAttribute('data-form-id') || '';
    var cents = parseInt(wrap.getAttribute('data-price'), 10);
    var group = null;
    toArray(document.querySelectorAll('[data-sp-bundle]')).forEach(function (g) {
      if (!group && (!formId || g.getAttribute('data-form-id') === formId)) group = g;
    });
    var radio = group && group.querySelector('input[name="om-bundle"]:checked');
    var tier = radio && radio.closest('[data-sp-final]');
    if (tier) {
      cents = parseInt(tier.getAttribute('data-sp-final'), 10);
      if (group.hasAttribute('data-sp-whole')) cents = Math.round(cents / 100) * 100;
    }
    var shown = isNaN(cents) ? null : fmt(cents);
    if (shown !== null) el.textContent = shown;
  }

  function allSticky() { toArray(document.querySelectorAll('[data-sp-sticky]')).forEach(stickyPrice); }

  function deliveryPrice(cell, v) {
    var price = parseInt(v.price, 10);
    var cmp = parseInt(v.compare_at_price, 10) || 0;
    if (isNaN(price) || !(cmp > price)) return;
    var now = fmt(price);
    var before = fmt(cmp);
    var saved = fmt(cmp - price);
    if (now === null) return;
    var set = function (sel, text) { var el = cell.querySelector(sel); if (el) el.textContent = text; };
    set('[data-sp-dp-now]', now);
    set('[data-sp-dp-before]', before);
    set('[data-sp-dp-badge]', String(cell.getAttribute('data-sp-tpl-badge') || '').replace('[amount]', saved));
    set('[data-sp-dp-aria]', String(cell.getAttribute('data-sp-tpl-aria') || '').replace('[price]', now).replace('[before]', before).replace('[amount]', saved));
  }

  document.addEventListener('sp:bundle:change', function () { setTimeout(allSticky, 0); });
  document.addEventListener('variant:change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || v.price == null) return;
    toArray(document.querySelectorAll('[data-sp-sticky]')).forEach(function (wrap) {
      if (wrap.hasAttribute('data-price')) wrap.setAttribute('data-price', String(parseInt(v.price, 10)));
    });
    setTimeout(allSticky, 0);
    toArray(document.querySelectorAll('[data-sp-delivery-price]')).forEach(function (cell) { deliveryPrice(cell, v); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', allSticky);
  else allSticky();
  document.addEventListener('shopify:section:load', allSticky);
})();
